export default __webpack_public_path__ + "static/media/spotify.8da8975f.svg";